module.exports = __webpack_public_path__ + "static/media/spinner.e25ae7b6df.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/spinner.svg
// module id = 6199
// module chunks = 0